import { render, staticRenderFns } from "./compare-report-table.vue?vue&type=template&id=4e97007b"
import script from "./compare-report-table.vue?vue&type=script&lang=js"
export * from "./compare-report-table.vue?vue&type=script&lang=js"
import style0 from "./compare-report-table.vue?vue&type=style&index=0&id=4e97007b&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports